var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLoader = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16.875 9c.621 0 1.132.506 1.055 1.122A9.001 9.001 0 0 1 1.719 14.29 9 9 0 0 1 10.692.16c.61.117.934.76.742 1.35s-.827.905-1.442.813a6.75 6.75 0 1 0 5.664 7.797c.103-.613.598-1.12 1.219-1.12"
})));
export default SvgLoader;